document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gifting-slider]').forEach((section) => {
    const track = section.querySelector('[data-slider-track]');
    const prevBtn = section.querySelector('[data-slider-prev]');
    const nextBtn = section.querySelector('[data-slider-next]');

    if (!track || !prevBtn || !nextBtn) return;

    const updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = track;
      const atStart = scrollLeft <= 1;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      prevBtn.classList.toggle('gifting-collection-slider__arrow--hidden', atStart);
      nextBtn.classList.toggle('gifting-collection-slider__arrow--hidden', atEnd);
    };

    const getScrollAmount = () => {
      const slide = track.querySelector('[data-slide]');
      if (!slide) return track.clientWidth;
      const gap = parseInt(getComputedStyle(track).gap, 10) || 0;
      return slide.offsetWidth + gap;
    };

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  });
});
